// extracted by mini-css-extract-plugin
module.exports = {"titlebar":"App_titlebar__izk_9","susanna":"App_susanna__2kxxA","scrollableArea":"App_scrollableArea__3llI1"};